import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Pagination,
} from "react-bootstrap";
import Base from "./base.js";
import { useRef, useState, useEffect } from "react";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { gql, useQuery, useLazyQuery, useReactiveVar } from "@apollo/client";
import { useSnackbar } from "react-simple-snackbar";
import {
  error_options,
  SNACK_DURATION,
  ERROR_MESSAGE,
  getDate,
  displayMiddleName,
  PER_PAGE_COUNT,
  urlActions,
  concatAllErrors,
} from "../Common/helpers";
import SelectPatientModal from "./SearchForPatient/selectPatientModal";
import { urlBackend } from "apolloSettings";
import Preloader from "../Common/Preloder/Preloader";
import { Link } from "react-router-dom";
import { accountsFilterVar } from "../cache/cache.js";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import { paymentsFilterVar } from "../cache/cache.js";
import * as Sentry from "@sentry/browser";
import { userDetailsVar } from "../cache/cache";
import { deepCopy } from "../Common/helpers";

export const REQUEST_DOCTOR = gql`
  query {
    doctors(active: true) {
      edges {
        node {
          firstName
          lastName
          arabicName
          id
          email
          identifier
          doctorId
        }
      }
    }
  }
`;

export default function Payments(props) {
  const patient_record = props.location.state
    ? props.location.state.patient_record
    : null;
  const identifier = patient_record ? patient_record.identifier : null;
  const searchPatientRef = useRef();
  const formikRef = useRef();
  const [activePage, setActivePage] = useState(1);
  const [openSnackbar] = useSnackbar(error_options);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showPatientSearch, setShowPatientSearch] = useState(false);
  const [exportLink, setExportLink] = useState(
    urlBackend +
      "admin/payment/paymentmodel/?paid__exact=1&active_payment=active"
  );
  const [defaultLink, setDefaultLink] = useState(
    urlBackend +
      "admin/payment/paymentmodel/?paid__exact=1&active_payment=active"
  );
  const accountsFilter = useReactiveVar(accountsFilterVar);
  const { t } = useTranslation();
  const paymetnsFilter = useReactiveVar(paymentsFilterVar);
  const [doctorsList, setDoctorList] = useState(null);

  var userDetails = useReactiveVar(userDetailsVar);
  if (userDetails) {
    userDetails = JSON.parse(userDetails);
  }

  useEffect(() => {
    let page = urlActions(window.location.href, "get", "page");
    if (page) {
      setActivePage(parseInt(page));
    }
  }, []);

  const REQUEST_PAYMENTS_FILTER = gql`
  query($start:DateTime, $end:DateTime, $doctor:String, $patient:String, $amount:Float)  {
    payments(
      start: $start, end: $end, 
      doctor_Identifier: $doctor, 
      patient_Identifier: $patient,
      amount:$amount,
      first:${PER_PAGE_COUNT}, 
      offset:${PER_PAGE_COUNT * (activePage - 1)}
      )
    {
      totalCount
      totalAmount   
      edges{
        node{
          created
          actualDate
          id
          patient{
            identifier
            firstName
            middleName
            lastName
            email
            phone
          }
          displayPaymentType
          amount
          datePaid
          displayReason
          currency
          notes
          sources{
            edges{
              node{
                reference
              }
            }
          }
          identifier
          appointment{
            created
            start
            id
            identifier
            discount
            originalPrice
            eventType{
              name
            }
            doctor{
              identifier
              firstName
              lastName
              arabicName
            }
          }
        }
      }
    }
  }
  `;
  const [getPaymentsFilter, { data: paymentsObjFilter = null, loading }] =
    useLazyQuery(REQUEST_PAYMENTS_FILTER, { fetchPolicy: "network-only" });

  useEffect(() => {
    if (accountsFilter) {
      if (accountsFilter.doctorIdentifier) {
        formikRef.current.setFieldValue(
          "doctor",
          accountsFilter.doctorIdentifier
        );
      }
      if (accountsFilter.amount) {
        formikRef.current.setFieldValue("amount", accountsFilter.amount);
      }
      if (accountsFilter.patient) {
        formikRef.current.setFieldValue(
          "patient",
          `${accountsFilter.patient.firstName} ${displayMiddleName(
            accountsFilter.patient.middleName
          )}${accountsFilter.patient.lastName}`
        );
        setSelectedPatient(accountsFilter.patient);
      }
      if (accountsFilter.startDate) {
        setStartDate(accountsFilter.startDate);
      }
      if (accountsFilter.endDate) {
        setEndDate(accountsFilter.endDate);
      }
      if (Object.keys(accountsFilter).length > 0) {
        formikRef.current.handleSubmit();
        setTimeout(() => {
          accountsFilterVar(null);
        }, 500);
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (patient_record) {
      setDefaultLink(
        urlBackend +
          "admin/payment/paymentmodel/?paid__exact=1&active_payment=active&patient__id__exact=" +
          patient_record.patientId
      );
      setExportLink(
        urlBackend +
          "admin/payment/paymentmodel/?paid__exact=1&active_payment=active&patient__id__exact=" +
          patient_record.patientId
      );
    }
  }, [patient_record]);

  const { data: rawDoctorsList } = useQuery(REQUEST_DOCTOR, {
    fetchPolicy: "network-only",
    onError: (e) => {
      Sentry.setContext("error", e?.networkError?.result);
      Sentry.setContext("ERROR OBJ ", { errorObj: e });
      Sentry.setContext("ERROR CODE statusCode ", {
        code: e?.networkError?.statusCode,
      });
      if (e?.message?.toLocaleLowerCase()?.indexOf("permission") < 0) {
        Sentry.captureException("REQUEST_DOCTOR error " + e);
      }

      let errorMsg = concatAllErrors(e?.graphQLErrors);
      let msgToDisplay = errorMsg ? errorMsg : ERROR_MESSAGE;
      openSnackbar(msgToDisplay, [SNACK_DURATION]);
    },
  });

  useEffect(() => {
    setDoctorList(deepCopy(rawDoctorsList));
  }, [rawDoctorsList]);

  const doctors =
    doctorsList && doctorsList.doctors
      ? doctorsList.doctors.edges.sort((a, b) =>
          a?.node?.firstName?.localeCompare(b?.node?.firstName)
        )
      : [];

  let canViewAppointments =
    userDetails &&
    userDetails?.canViewAppointments &&
    userDetails?.canViewAppointments.edges
      ? userDetails?.canViewAppointments.edges.map((doc) => {
          return doc.node.identifier;
        })
      : null;

  const onSelectPatient = (patientData) => {
    formikRef.current.setFieldValue(
      "patient",
      `${patientData.firstName} ${displayMiddleName(patientData.middleName)}${
        patientData.lastName
      }`
    );
    setSelectedPatient(patientData);
  };

  const onSubmit = (values) => {
    // since we have date variable in the filter query we need to pass a valid date
    //  hence creating dummy dates that will cover all dates incase date filter is not seleted
    // let defaultStart= new Date("2002/02/02");
    // let defaultEnd= new Date("2052/02/02");
    let startDateStr = "";
    let endDateStr = "";

    if (startDate) {
      let startDateObj = new Date(startDate);
      startDateStr = new Date(
        startDateObj.getTime() - startDateObj.getTimezoneOffset() * 60000
      ).toISOString();
    }
    if (endDate) {
      let endDateObj = new Date(endDate);
      endDateStr = new Date(
        endDateObj.getTime() - endDateObj.getTimezoneOffset() * 60000
      ).toISOString();
    }

    let variables = {};
    let doctorId = "";
    let patientId = "";
    let export_link = defaultLink;
    if (values.doctor) {
      variables["doctor"] = values.doctor;
      let doctorIdObj = doctors.find(
        (i) => i.node.identifier === values.doctor
      );
      if (doctorIdObj) {
        doctorId = doctorIdObj.node.doctorId;
        export_link = export_link + "&doctor__id__exact=" + doctorId;
      }
    }
    if (patient_record) {
      variables["patient"] = patient_record
        ? patient_record.node.identifier
        : "";
      patientId = patient_record.node.patientId;
    }
    if (selectedPatient) {
      variables["patient"] = selectedPatient ? selectedPatient.identifier : "";
      patientId = selectedPatient.patientId;
      export_link = export_link + "&patient__id__exact=" + patientId;
    }
    if (startDateStr) {
      variables["start"] = startDateStr;
      export_link =
        export_link +
        "&actual_date__range__gte=" +
        startDateStr.substring(0, 10);
    }
    if (endDateStr) {
      variables["end"] = endDateStr;
      export_link =
        export_link + "&actual_date__range__lte=" + endDateStr.substring(0, 10);
    }
    if (values.amount) {
      variables["amount"] = values.amount;
    }
    setExportLink(export_link);
    getPaymentsFilter({
      variables: variables,
    });
  };

  const initialValues = {
    doctor: "",
    patient: "",
    paidby: "",
  };

  /**
   * FORMIK NOTES:
   * Formik uses { handleSubmit, handleChange, handleBlur, values } inbuilt functions and onChnage={handleChange}
   * makes sure that values object in submit will have the changed/updated values for input
   *
   * if we need to add custom functions onChange then similar to onChange={handleSearch} for patient we can use custom function but
   * make sure to set the formik value of that field using formikRef.current.setFieldValue('patient', event.target.value);
   * formikRef is the innerRef given to formik component   *
   *
   */
  const goToDetailPage = () => {
    if (
      selectedPatient ||
      formikRef.current.values.doctor ||
      formikRef.current.values.amount ||
      startDate ||
      endDate
    ) {
      accountsFilterVar({
        patient: selectedPatient,
        doctorIdentifier: formikRef.current.values.doctor,
        startDate: startDate,
        endDate: endDate,
        amount: formikRef.current.values.amount,
      });
    } else {
      accountsFilterVar(null);
    }
  };

  const checkHasPermission = (paymentItem) => {
    if (userDetails?.isSuperuser) {
      return true;
    } else if (
      canViewAppointments?.some(
        (i) => i === paymentItem?.appointment?.doctor?.identifier
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const renderList = (paymentListObj) => {
    let payment_list =
      paymentListObj && paymentListObj.payments
        ? paymentListObj.payments.edges
        : [];
    if (payment_list.length > 0) {
      return payment_list.map((itemNode, index) => {
        let item = itemNode.node;
        let date = new Date(item.actualDate);

        let canViewCurrentAppointments = checkHasPermission(item);
        return (
          <tr key={index} className="patient_table_row">
            <td>
              {!canViewCurrentAppointments ? (
                <Link
                  to={"/accounts/payment/detail/" + item.id}
                  onClick={goToDetailPage}
                  className="d-inline-block"
                >
                  {getDate(date)}
                </Link>
              ) : (
                <Link
                  to={
                    item?.appointment === null
                      ? "/accounts/payment/detail/" + item.id
                      : "/appointment/detail/" + item?.appointment?.id
                  }
                  onClick={goToDetailPage}
                  className="d-inline-block"
                >
                  {getDate(date)}
                </Link>
              )}
            </td>
            <td>{item.identifier}</td>
            {!patient_record ? (
              <td>
                {item.patient
                  ? item.patient.firstName +
                    " " +
                    displayMiddleName(item.patient.middleName) +
                    item.patient.lastName
                  : ""}
              </td>
            ) : null}
            <td>
              {item.appointment
                ? item.appointment?.eventType?.name
                : item.displayReason}{" "}
            </td>
            <td>
              {item.appointment ? item.appointment.originalPrice : item.amount}{" "}
              {item.currency}
            </td>
            <td>
              {item.appointment
                ? item.appointment.discount
                  ? Math.round(item.appointment.discount)
                  : "0"
                : "0"}
              %
            </td>
            <td>
              {item.amount} {item.currency}
            </td>
            <td>{item.datePaid ? getDate(new Date(item.datePaid)) : "-"}</td>
            <td>{item.displayPaymentType}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td>{t("No payment data available")}</td>
        </tr>
      );
    }
  };

  const resetFilter = () => {
    if (formikRef && formikRef.current) {
      formikRef.current.handleReset();
      setSelectedPatient(null);
      setStartDate("");
      setEndDate("");
    }
    accountsFilterVar(null);
    getPaymentsFilter();
  };

  useEffect(() => {
    if (identifier) {
      let variables = {};
      variables["patient"] = identifier;
      getPaymentsFilter({
        variables: variables,
      });
    } else {
      getPaymentsFilter();
    }
  }, [identifier]);

  const process_query_string = (data = {}) => {
    let query_string_obj = queryString.parse(window.location.search);

    // current filter key, values
    if (Object.keys(data).length <= 0) {
      data = paymetnsFilter;
    }

    for (const item in data) {
      query_string_obj[item] = data[item];
    }

    return query_string_obj;
  };

  const handlePageChange = (number) => {
    setActivePage(number);
    let query_string = process_query_string();
    query_string["page"] = number;
    const stringified = queryString.stringify(query_string);
    window.history.pushState(null, "", "?" + stringified);
  };

  const renderPages = () => {
    let total_pages = paymentsObjFilter?.payments?.totalCount
      ? Math.ceil(paymentsObjFilter?.payments?.totalCount / PER_PAGE_COUNT)
      : 1;

    if (total_pages > 1) {
      let currentpage = [];
      if (activePage == 1) {
        currentpage = [
          <Pagination.Item active={true} onClick={() => handlePageChange(1)}>
            {activePage}
          </Pagination.Item>,
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(activePage + 1)}
          >
            {activePage + 1}
          </Pagination.Item>,
        ];
      } else if (activePage == total_pages) {
        currentpage = [
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(activePage - 1)}
          >
            {activePage - 1}
          </Pagination.Item>,
          <Pagination.Item
            active={true}
            onClick={() => handlePageChange(total_pages)}
          >
            {activePage}
          </Pagination.Item>,
        ];
      } else {
        currentpage = [
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(activePage - 1)}
          >
            {activePage - 1}
          </Pagination.Item>,
          <Pagination.Item
            active={true}
            onClick={() => handlePageChange(activePage)}
          >
            {activePage}
          </Pagination.Item>,
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(activePage + 1)}
          >
            {activePage + 1}
          </Pagination.Item>,
        ];
      }

      let itemsStart = [];
      if (activePage == 1 || activePage == 2) {
        itemsStart = [
          <Pagination.First
            disabled={activePage === 1}
            onClick={() => handlePageChange(1)}
          />,
          <Pagination.Prev
            disabled={activePage === 1}
            onClick={() => handlePageChange(activePage - 1)}
          />,
        ];
      } else if (activePage == 3) {
        itemsStart = [
          <Pagination.First
            disabled={activePage === 1}
            onClick={() => handlePageChange(1)}
          />,
          <Pagination.Prev
            disabled={activePage === 1}
            onClick={() => handlePageChange(activePage - 1)}
          />,
          <Pagination.Item active={false} onClick={() => handlePageChange(1)}>
            {1}
          </Pagination.Item>,
        ];
      } else {
        itemsStart = [
          <Pagination.First
            disabled={activePage === 1}
            onClick={() => handlePageChange(1)}
          />,
          <Pagination.Prev
            disabled={activePage === 1}
            onClick={() => handlePageChange(activePage - 1)}
          />,
          <Pagination.Item active={false} onClick={() => handlePageChange(1)}>
            {1}
          </Pagination.Item>,
          <Pagination.Ellipsis disabled={true} />,
        ];
      }

      let itemsEnd = [];
      if (activePage == total_pages || activePage == total_pages - 1) {
        itemsEnd = [
          <Pagination.Next
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(activePage + 1)}
          />,
          <Pagination.Last
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(total_pages)}
          />,
        ];
      } else if (activePage == total_pages - 2) {
        itemsEnd = [
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(total_pages)}
          >
            {total_pages}
          </Pagination.Item>,
          <Pagination.Next
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(activePage + 1)}
          />,
          <Pagination.Last
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(total_pages)}
          />,
        ];
      } else {
        itemsEnd = [
          <Pagination.Ellipsis disabled={true} />,
          <Pagination.Item
            active={false}
            onClick={() => handlePageChange(total_pages)}
          >
            {total_pages}
          </Pagination.Item>,
          <Pagination.Next
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(activePage + 1)}
          />,
          <Pagination.Last
            disabled={activePage === total_pages}
            onClick={() => handlePageChange(total_pages)}
          />,
        ];
      }

      let allPages = [...itemsStart, ...currentpage, ...itemsEnd];
      return allPages;
    }
  };

  return (
    <Base
      title={`${
        patient_record
          ? `${patient_record.firstName} ${displayMiddleName(
              patient_record.middleName
            )}${patient_record.lastName} Payment Records`
          : "Accounts"
      }`}
      showHeader={true}
    >
      <Row className="payment-section">
        <Col md={12} lg={12} className="mr-auto">
          <Formik
            onSubmit={onSubmit}
            initialValues={initialValues}
            innerRef={formikRef}
          >
            {({ handleSubmit, handleChange, handleBlur, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="justify-content-end">
                  <Col md={12} lg={6} xl={2} sm={12}>
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm={3}
                        md={3}
                        lg={3}
                        className="text-right pr-0"
                      >
                        From
                      </Form.Label>
                      <Col sm={12} md={9} lg={9}>
                        <DatePicker
                          autoComplete="off"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          className="form-control"
                          dateFormat="dd/MMM/yyyy"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={6} xl={2} sm={12}>
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm={3}
                        md={3}
                        lg={3}
                        className="text-right pr-0"
                      >
                        To
                      </Form.Label>
                      <Col sm={12} md={9} lg={9}>
                        <DatePicker
                          autoComplete="off"
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control"
                          dateFormat="dd/MMM/yyyy"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={6} xl={4} sm={12}>
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm={3}
                        md={3}
                        lg={3}
                        className="text-right pr-0"
                      >
                        Practitioner
                      </Form.Label>
                      <Col sm={12} md={9} lg={9}>
                        <Form.Control
                          autoComplete="off"
                          onBlur={handleBlur}
                          as="select"
                          name="doctor"
                          value={values.doctor}
                          onChange={handleChange}
                        >
                          <option value="">Select Practitioner</option>
                          {doctors.map((doctor) => {
                            return (
                              <option
                                value={doctor.node.identifier}
                                key={doctor.node.id}
                              >
                                {doctor.node.firstName} {doctor.node.lastName}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col
                    md={12}
                    lg={6}
                    xl={4}
                    sm={12}
                    className={`${patient_record ? "d-none" : "d-block"}`}
                  >
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm={3}
                        md={3}
                        lg={3}
                        className="text-right pr-0"
                      >
                        Patient
                      </Form.Label>
                      <Col
                        sm={12}
                        md={9}
                        lg={9}
                        className="payment-section__patient-search"
                        ref={searchPatientRef}
                      >
                        <Form.Control
                          autoComplete="off"
                          placeholder="Select Patient"
                          type="text"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          name="patient"
                          value={values.patient}
                          className="mr-sm-2 pr-0 float-left pr-5"
                        />
                        <span
                          onClick={() => setShowPatientSearch(true)}
                          className="search-icon"
                        >
                          <i className="fa fa-search"></i>
                        </span>
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={6} xl={4} sm={12} className="ml-auto">
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm={3}
                        md={3}
                        lg={3}
                        className="text-right pr-0"
                      >
                        Amount
                      </Form.Label>
                      <Col sm={12} md={9} lg={9}>
                        <Form.Control
                          autoComplete="off"
                          placeholder="Enter Amount"
                          type="text"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          name="amount"
                          value={values.amount}
                          className="mr-sm-2 pr-0 float-left pr-5"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={6} xl={4} sm={12}>
                    <div
                      className={`d-flex justify-content-end submitPayment ${
                        patient_record ? "pt-3" : ""
                      }`}
                    >
                      <Button
                        type="button"
                        variant="primary"
                        onClick={() => {
                          setTimeout(() => {
                            window.open(exportLink, "_blank");
                          }, 300);
                        }}
                      >
                        {" "}
                        Export{" "}
                      </Button>
                      <Button
                        type="button"
                        variant="primary"
                        className="mx-3"
                        onClick={resetFilter}
                      >
                        {" "}
                        Reset{" "}
                      </Button>
                      <Button type="submit" variant="primary">
                        {" "}
                        Submit{" "}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
        <Col md={12} className="mb-4">
          {loading ? (
            <Preloader />
          ) : (
            <Card className="paymentListCard">
              <Card.Body className="p-0">
                <Table responsive className=" table-borderless">
                  <thead>
                    <tr className="patient_table_row tableHeader">
                      {/* <th scope="col " className="text-uppercase">Transaction ID</th> */}
                      <th scope="col " className="text-uppercase">
                        Date
                      </th>
                      <th scope="col " className="text-uppercase">
                        Xero Invoice #
                      </th>
                      {!patient_record ? (
                        <th scope="col " className="text-uppercase">
                          Patient Name{" "}
                        </th>
                      ) : null}
                      <th scope="col " className="text-uppercase">
                        Service
                      </th>
                      <th scope="col " className="text-uppercase">
                        Amount
                      </th>
                      <th scope="col " className="text-uppercase">
                        Discount
                      </th>
                      <th scope="col " className="text-uppercase">
                        Total
                      </th>
                      <th scope="col " className="text-uppercase">
                        Date Paid
                      </th>
                      <th scope="col " className="text-uppercase">
                        Payment Type
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentsObjFilter ? renderList(paymentsObjFilter) : null}
                    {paymentsObjFilter ? (
                      <tr>
                        <td colSpan="5"></td>
                        <td className="text-uppercase font-bold">
                          Total Amount
                        </td>
                        <td className="text-uppercase font-bold">
                          {paymentsObjFilter.payments.totalAmount} KWD
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
      <div className="text-center">
        {paymentsObjFilter?.payments?.totalCount > PER_PAGE_COUNT ? (
          <div className="paginationContainer pt-5">
            <Pagination>{renderPages()}</Pagination>
          </div>
        ) : null}
      </div>
      <SelectPatientModal
        showPatientSearch={showPatientSearch}
        setShowPatientSearch={setShowPatientSearch}
        onSelectPatientFunc={onSelectPatient}
      />
    </Base>
  );
}
